// 🔧 use_promotion_publishing.js
// ✅ Purpose: React hook for publishing Promotion Posts
// ✅ Features:
// - Publishes Promotion Posts through secure Cloud Functions
// - Tracks publishing state
// - Stores latest publish result
// - Stores latest publish error
// - Keeps React pages free from publishing implementation details
// - Future-ready for multiple social providers
// - Fully block-commented for clarity and future devs

import { useState } from "react";

import {
  publishPromotionPost,
} from "../services/promotion_publishing_service";

/**
 * ============================================================================
 * usePromotionPublishing
 * ============================================================================
 *
 * Standard publishing hook for the Promotion Engine.
 */
export const usePromotionPublishing = () => {

  const [publishing, setPublishing] =
    useState(false);

  const [publishResult, setPublishResult] =
    useState(null);

  const [publishError, setPublishError] =
    useState(null);

  /**
   * --------------------------------------------------------------------------
   * Publish Promotion Post
   * --------------------------------------------------------------------------
   */

  const publish = async ({
    postId,
  }) => {

    setPublishing(true);

    setPublishError(null);

    try {

      const result =
        await publishPromotionPost({
          postId,
        });

      setPublishResult(result);

      return result;

    } catch (error) {

      console.error(
        "[Promotion Publishing]",
        error
      );

      setPublishError(error);

      throw error;

    } finally {

      setPublishing(false);

    }

  };

  /**
   * --------------------------------------------------------------------------
   * Clear Publish Result
   * --------------------------------------------------------------------------
   */

  const clearPublishResult = () => {

    setPublishResult(null);

    setPublishError(null);

  };

  return {

    publishing,

    publishResult,

    publishError,

    publish,

    clearPublishResult,

  };

};